module.exports = __webpack_public_path__ + "static/media/sad.baad2ca9.mp3";